/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ currentYear: NonNullable<unknown> }} Copyright_Brave_SoftwareInputs */

const en_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const id_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const ms_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const ca_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const cs_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const da_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const de_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const et_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const es_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const fr_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const hr_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const it_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const lv_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const lt_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const hu_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const nl_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const nb_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const pl_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const pt_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const ro_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const sk_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const sl_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const fi_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const sv_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const vi_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const tr_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const el_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const bg_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const ru_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const sr_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const uk_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const ka_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const hi_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const th_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const ko_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const zh_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc。`)
};

const zh_tw_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

const ja_copyright_brave_software = /** @type {(inputs: Copyright_Brave_SoftwareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currentYear} © Brave Software, Inc.`)
};

/**
* | output |
* | --- |
* | "{currentYear} © Brave Software, Inc." |
*
* @param {Copyright_Brave_SoftwareInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const copyright_brave_software = /** @type {((inputs: Copyright_Brave_SoftwareInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copyright_Brave_SoftwareInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_copyright_brave_software(inputs)
	if (locale === "ms") return ms_copyright_brave_software(inputs)
	if (locale === "ca") return ca_copyright_brave_software(inputs)
	if (locale === "cs") return cs_copyright_brave_software(inputs)
	if (locale === "da") return da_copyright_brave_software(inputs)
	if (locale === "de") return de_copyright_brave_software(inputs)
	if (locale === "et") return et_copyright_brave_software(inputs)
	if (locale === "es") return es_copyright_brave_software(inputs)
	if (locale === "fr") return fr_copyright_brave_software(inputs)
	if (locale === "hr") return hr_copyright_brave_software(inputs)
	if (locale === "it") return it_copyright_brave_software(inputs)
	if (locale === "lv") return lv_copyright_brave_software(inputs)
	if (locale === "lt") return lt_copyright_brave_software(inputs)
	if (locale === "hu") return hu_copyright_brave_software(inputs)
	if (locale === "nl") return nl_copyright_brave_software(inputs)
	if (locale === "nb") return nb_copyright_brave_software(inputs)
	if (locale === "pl") return pl_copyright_brave_software(inputs)
	if (locale === "pt") return pt_copyright_brave_software(inputs)
	if (locale === "ro") return ro_copyright_brave_software(inputs)
	if (locale === "sk") return sk_copyright_brave_software(inputs)
	if (locale === "sl") return sl_copyright_brave_software(inputs)
	if (locale === "fi") return fi_copyright_brave_software(inputs)
	if (locale === "sv") return sv_copyright_brave_software(inputs)
	if (locale === "vi") return vi_copyright_brave_software(inputs)
	if (locale === "tr") return tr_copyright_brave_software(inputs)
	if (locale === "el") return el_copyright_brave_software(inputs)
	if (locale === "bg") return bg_copyright_brave_software(inputs)
	if (locale === "ru") return ru_copyright_brave_software(inputs)
	if (locale === "sr") return sr_copyright_brave_software(inputs)
	if (locale === "uk") return uk_copyright_brave_software(inputs)
	if (locale === "ka") return ka_copyright_brave_software(inputs)
	if (locale === "hi") return hi_copyright_brave_software(inputs)
	if (locale === "th") return th_copyright_brave_software(inputs)
	if (locale === "ko") return ko_copyright_brave_software(inputs)
	if (locale === "zh") return zh_copyright_brave_software(inputs)
	if (locale === "zh-tw") return zh_tw_copyright_brave_software(inputs)
	if (locale === "ja") return ja_copyright_brave_software(inputs)
	return en_copyright_brave_software(inputs)
});